<template>
    <div :class="phoneInputClass">
        <div :class="areaCodeClass">
            {{ countryCode }}
        </div>
        <input
            v-bind="attrs"
            :value="prefill || value"
            :placeholder="placeholder"
            :autofocus="hasAutofocus"
            :required="isRequired"
            :disabled="isDisabled"
            type="tel"
            @blur="emitEvent({ name: 'blur' })"
            @focus="emitEvent({ name: 'focus' })"
            @input="change($event)"
        />
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            value: { type: [String, Number], default: undefined },
            prefill: { type: [String, Number], default: undefined },
            placeholder: { type: String, default: undefined },
            countryCodePath: { type: String, required: true },
        },

        data() {
            return {
                countryCode: '+1',
            }
        },

        computed: {
            phoneInputClass() {
                return {
                    'form-input-text': true,
                    'form-phone-input': true,
                    'form-input-text--is-invalid': this.isInvalid,
                    'form-input-text--is-disabled': this.isDisabled,
                    'form-input-text--is-prefilled': Boolean(this.prefill),
                }
            },

            areaCodeClass() {
                return {
                    'form-phone-input__area-code': true,
                    'form-phone-input__area-code--disabled': this.isDisabled,
                }
            },
        },

        methods: {
            countryCodeChange() {
                const payload = {}
                payload[this.countryCodePath] = this.countryCode

                this.emitEvent({ name: 'country-code-change', payload })
            },
        },

        mounted() {
            this.countryCodeChange()
        },
    }
</script>
